<template>
  <div class="">
    <div class="singlework container">
      <section class="cover-img">
        <div>
          <img :src="coverimg" alt="" />
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  props: ["coverimg"],
};
</script>